import React, { useEffect, useState } from "react";
import { Button, Input, Table, Tooltip, message } from "antd";
import { AiFillDelete, AiFillEdit } from "react-icons/ai";
import { BsSearch, BsX } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

import PlantModal from "../components/modules/plant/plantModal";
import ImportModal from "../components/modules/importModal";
import ConfirmationModal from "../components/common/confirmationModal";
import {
  asyncDeleteAllPlant,
  asyncDeletePlant,
  asyncDeleteSelectedPlant,
  asyncGetPlant,
  asyncImportPlant,
} from "../redux/slices/plantSlice";
import ImportReportPlant from "../components/modules/plant/importReport";

const { Column } = Table;

const Plants = () => {
  const dispatch = useDispatch();
  const {
    loading,
    data,
    pagination,
    deleteLoading,
    importLoading,
    deleteAllLoading,
    deleteSelectedLoading,
  } = useSelector((state) => ({
    loading: state.plant.getPlant.loading,
    data: state.plant.getPlant.data,
    pagination: state.plant.getPlant.pagination,
    deleteLoading: state.plant.deletePlant.loading,
    importLoading: state.plant.importPlant.loading,
    deleteAllLoading: state.plant.deleteAllPlant.loading,
    deleteSelectedLoading: state.plant.deleteSelectedPlant.loading,
  }));

  const initModalData = {
    plantName: "",
    code: "",
    state: "",
    city: "",
    latitude: "",
    longitude: "",
    // terminal_id: "",
  };

  const [currentColumn, setCurrentColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [deleteId, setDeleteId] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [modalData, setModalData] = useState({
    mode: "",
    data: initModalData,
  });
  const [file, setFile] = useState(null);
  const [openModalReport, setOpenModalReport] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [isDeleteAll, setIsDeleteAll] = useState(false);
  const [isDeleteSelected, setIsDeleteSelected] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const header = () => {
    return (
      <div>
        <div className="table_header">
          <div className="button_margin">
            <Input
              placeholder={"Search Plant"}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              className="search_input"
              prefix={<BsSearch />}
              suffix={
                searchText && (
                  <BsX
                    style={{ cursor: "pointer" }}
                    onClick={() => setSearchText("")}
                  />
                )
              }
            />
          </div>
          <div className="table_header_button">
            <Button
              className="button_margin"
              onClick={() => {
                setOpenImportModal(true);
              }}
            >
              Import
            </Button>
            <Button
              className="button_margin"
              onClick={() => {
                const filePath = "/sampleSheet/sample_plant.csv";
                window.open(filePath, "_blank");
              }}
            >
              Download Import Template
            </Button>
            <Button
              onClick={() => {
                setOpenModal(true);
                setModalData({
                  mode: "add",
                  data: initModalData,
                });
              }}
            >
              Create New
            </Button>
          </div>
        </div>
        <div className="table_header_down">
          {pagination?.totalItems > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteAll(true);
              }}
            >
              {`Delete all available data`}
            </Button>
          )}
          {selectedIds.length > 0 && (
            <Button
              className="button_margin"
              onClick={() => {
                setIsDeleteSelected(true);
              }}
            >
              {`Delete selected (${selectedIds.length}) data`}
            </Button>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (!isInitialRender) {
      const delay = 500;
      const timeoutId = setTimeout(() => {
        dispatch(
          asyncGetPlant({
            page: 1,
            limit: 10,
            q: searchText,
          })
        );
      }, delay);
      return () => clearTimeout(timeoutId);
    } else {
      setIsInitialRender(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  const handleSubmit = () => {
    setOpenModalReport(false);
    setErrorData([]);
    setSuccessData([]);
    if (file) {
      const formData = new FormData();
      formData.append("upload", file);
      formData.append("isChecked", isChecked || false);

      dispatch(asyncImportPlant(formData)).then((res) => {
        if (res.payload?.status === 200) {
          if (res.payload.data) {
            setErrorData(res.payload.data?.errorData || []);
            setSuccessData(res.payload.data?.newResponse || []);
            setOpenModalReport(true);
          }
          setOpenImportModal(false);
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          dispatch(
            asyncGetPlant({
              page: 1,
              limit: 10,
            })
          );
          setFile(null);
          setIsChecked(false);
        } else {
          setOpenImportModal(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
          setFile(null);
          setIsChecked(false);
        }
      });
    } else {
      setOpenImportModal(false);
      messageApi.open({
        type: "error",
        content: "Please select file",
      });
      setIsChecked(false);
    }
  };

  const handleDelete = () => {
    if (deleteId) {
      dispatch(asyncDeletePlant(deleteId)).then((res) => {
        setConfirmation(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          dispatch(
            asyncGetPlant({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
          setDeleteId(0);
        } else {
          setConfirmation(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      });
    }
  };

  const handleDeleteAll = () => {
    dispatch(asyncDeleteAllPlant()).then((res) => {
      setIsDeleteAll(false);
      if (res.payload?.status === 200) {
        messageApi.open({
          type: "success",
          content: res.payload?.data?.message,
        });
        dispatch(
          asyncGetPlant({
            page: pagination.page || 1,
            limit: pagination.pageSize || 10,
            q: searchText,
          })
        );
      } else {
        setIsDeleteAll(false);
        messageApi.open({
          type: "error",
          content: res.payload?.message,
        });
      }
    });
  };

  const handleDeleteSelected = () => {
    dispatch(asyncDeleteSelectedPlant({ ids: selectedIds ?? [] })).then(
      (res) => {
        setIsDeleteSelected(false);
        if (res.payload?.status === 200) {
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          setSelectedIds([]);
          dispatch(
            asyncGetPlant({
              page: pagination.page || 1,
              limit: pagination.pageSize || 10,
              q: searchText,
            })
          );
        } else {
          setIsDeleteSelected(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
        }
      }
    );
  };

  const fetchData = (page, pageSize, sortOrder, column) => {
    dispatch(
      asyncGetPlant({
        page,
        limit: pageSize,
        sortOrder: sortOrder,
        sortByColumn: column,
        q: searchText,
      })
    );
  };

  const handleSort = (column) => {
    let newSortOrder;

    if (column !== currentColumn) {
      newSortOrder = "ASC";
    } else {
      if (sortOrder === "ASC") {
        newSortOrder = "DESC";
      } else if (sortOrder === "DESC") {
        newSortOrder = "";
      } else {
        newSortOrder = "ASC";
      }
    }

    setSortOrder(newSortOrder);
    setCurrentColumn(column);
    fetchData(1, 10, newSortOrder, column);
  };

  const onPageChange = (page, pageSize) => {
    fetchData(page, pageSize, sortOrder, currentColumn);
  };

  useEffect(() => {
    dispatch(
      asyncGetPlant({
        page: pagination.page,
        limit: pagination.pageSize,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedIds(selectedRowKeys);
    },
  };

  return (
    <div>
      {contextHolder}
      <div className="table_name">Plants</div>
      <div>{header()}</div>
      <Table
        rowKey={(record) => record?.id}
        rowSelection={Object.assign({ type: "checkbox" }, rowSelection)}
        dataSource={data}
        bordered
        size="small"
        loading={loading}
        // scroll={{ y: 400 }}
        pagination={{
          current: pagination.page,
          pageSize: pagination.pageSize,
          total: pagination?.totalItems,
          onChange: (page, pageSize) => {
            onPageChange(page, pageSize);
          },
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
      >
        <Column
          title="Name"
          key="plantName"
          render={(record) => record?.plantName}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("plantName"),
          })}
        />
        <Column
          title="Code"
          key="code"
          render={(record) => record?.code}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("code"),
          })}
        />

        <Column
          title="State"
          key="state"
          render={(record) => record?.state}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("state"),
          })}
        />
        <Column
          title="City"
          key="city"
          render={(record) => record?.city}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("city"),
          })}
        />

        <Column
          title="Longitude"
          key="longitude"
          render={(record) => record?.longitude}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("longitude"),
          })}
        />
        <Column
          title="Latitude"
          key="latitude"
          render={(record) => record?.latitude}
          sorter={true}
          onHeaderCell={() => ({
            onClick: () => handleSort("latitude"),
          })}
        />
        {/* <Column
          title="Terminal"
          key="terminal"
          render={(record) => record?.terminal?.name}
        /> */}
        <Column
          title="Action"
          key="action"
          width="10%"
          align="center"
          render={(rowData) => (
            <div className="table_icon">
              <Tooltip title="Edit">
                <i
                  onClick={() => {
                    setOpenModal(true);
                    setModalData({
                      mode: "edit",
                      data: rowData,
                    });
                  }}
                >
                  <AiFillEdit size={20} className="edit_icon" />
                </i>
              </Tooltip>
              <Tooltip title="Delete">
                <i
                  onClick={() => {
                    setConfirmation(true);
                    setDeleteId(rowData?.id);
                  }}
                >
                  <AiFillDelete size={20} className="delete_icon" />
                </i>
              </Tooltip>
            </div>
          )}
        />
      </Table>
      {openModal && (
        <PlantModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          messageApi={messageApi}
          modalData={modalData}
        />
      )}
      {openImportModal && (
        <ImportModal
          openModal={openImportModal}
          setOpenModal={setOpenImportModal}
          setFile={setFile}
          handleSubmit={handleSubmit}
          loading={importLoading}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          isCheckboxShow={true}
        />
      )}
      {confirmation && (
        <ConfirmationModal
          title={"Delete Plant"}
          open={confirmation}
          setOpen={setConfirmation}
          onYes={handleDelete}
          loading={deleteLoading}
        />
      )}
      {isDeleteAll && (
        <ConfirmationModal
          title={"Delete Plant"}
          message={"Are you sure you want to delete all available plants?"}
          open={isDeleteAll}
          setOpen={setIsDeleteAll}
          onYes={handleDeleteAll}
          loading={deleteAllLoading}
        />
      )}
      {isDeleteSelected && (
        <ConfirmationModal
          title={"Delete Plant"}
          message={"Are you sure you want to delete selected plants?"}
          open={isDeleteSelected}
          setOpen={setIsDeleteSelected}
          onYes={handleDeleteSelected}
          loading={deleteSelectedLoading}
        />
      )}
      {openModalReport && (
        <ImportReportPlant
          openModal={openModalReport}
          setOpenModal={setOpenModalReport}
          errorData={errorData}
          successData={successData}
        />
      )}
    </div>
  );
};

export default Plants;
